import { getCurrentLanguage } from '@luna/i18n';

export function getLocalizedCurrencyName(currency: string): string | undefined {
    const name = new Intl.DisplayNames(getCurrentLanguage(), {
        type: 'currency',
    }).of(currency);

    return name ?? currency;
}
